import apiService, { getDefaultHeader, getDSEHeader, getCdmsBaseUrl, getDseUrl, getMediaUrl } from './apiService';

var getCDMSBaseURL = function getCDMSBaseURL() {
  return getCdmsBaseUrl();
};

var getMediaUrls = function getMediaUrls(file) {
  var apiUrl = '/w/u/upload';
  var baseMediaURL = "".concat(getMediaUrl());
  return apiService(baseMediaURL, getDefaultHeader()).post(apiUrl, file, {
    attachment: true,
    async: false
  }).then(function (_ref) {
    var data = _ref.data;
    return data;
  });
};

var getCDMSSignedUrls = function getCDMSSignedUrls(mediaIdObject) {
  var apiUrl = '/r/u/presignedurls';
  var baseMediaURL = "".concat(getMediaUrl());
  return apiService(baseMediaURL, getDefaultHeader()).post(apiUrl, mediaIdObject).then(function (_ref2) {
    var data = _ref2.data;
    return data;
  });
};

var getDSESignedUrls = function getDSESignedUrls(mediaIdObject) {
  var apiUrl = '/tmedia/signed/URLs';
  var baseMediaURL = "".concat(getDseUrl());
  return apiService(baseMediaURL, getDSEHeader()).post(apiUrl, mediaIdObject).then(function (_ref3) {
    var data = _ref3.data;
    return data;
  });
};

export { getDefaultHeader as getHeaders, getCDMSBaseURL as getBaseURL };
export default {
  getMediaUrls: getMediaUrls,
  getCDMSSignedUrls: getCDMSSignedUrls,
  getDSESignedUrls: getDSESignedUrls
};